export const EmployeesStatus = () => {
    return [
        {value: "team_lead", label: "Team Lead"},
        {value: "project_lead", label: "Project Lead"},
        {value: "employee", label: "Employee"},
    ]
}